async function register(data, urls, Formatter, Network) {
  const url = urls.register
  const response = await sendRequest(data, url, Network)
  const parsedResponse = parseResponse(response, Formatter, Network)
  return parsedResponse
}

async function sendRequest(data, url, Network) {
  const reqData = {
    firstName: data.firstName,
    lastName: data.lastName,
    phoneNumber: '000000000000',
    email: data.email,
    password: data.password,
    metadata: {
      pictureUrl: data?.pictureUrl,
    },
  }

  const response = await Network.sendPostRequest(url, reqData)
  return response
}

function parseResponse(response, Formatter, Network) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    const rawUser = response.response.user
    const user = Formatter.parseExternalUser(rawUser)

    return {
      success: true,
      user,
    }
  }
  if (response.status.code === 409) {
    return {
      success: false,
      badPassword: true,
      messageId: 'messages.register.accountAlreadyExists',
    }
  }
  return Network.defaultResponseParsing(response)
}

export { register }
